import { useEffect, useState } from 'react';
import { ValidDataService } from '../../../../service/validDataService';
import { formatDateWithTimezone } from '../../../../utils';

export const useValidInventoryContactColumns = () => {
    const [locations, setLocations] = useState([]);
    const [brands, setBrands] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [materials, setMaterials] = useState([]);
    const [contactLensType, setContactLensType] = useState([]);

    useEffect(() => {
        // Helper function to fetch data and update state, reducing redundancy
        const fetchInventoryOptions = async (serviceMethod, setStateFunction, property) => {
            try {
                const response = await serviceMethod('contacts');
                const { code, data } = response;
                if (code === 0) {
                    const options = data.map(item => ({
                        value: item.value,
                        label: item.label
                    }));
                    setStateFunction(options);
                }
            } catch (error) {
                console.error(`Error fetching ${property}:`, error);
            }
        };

        const fetchPropertyOptions = async (serviceMethod, setStateFunction, property) => {
            try {
                const response = await serviceMethod('contacts', property);
                const { code, data } = response;
                if (code === 0) {
                    const options = data.map(item => ({
                        value: item.value,
                        label: item.label
                    }));
                    setStateFunction(options);
                }
            } catch (error) {
                console.error(`Error fetching ${property}:`, error);
            }
        };

        fetchInventoryOptions(ValidDataService.getValidSupplierFilterOptions, setSuppliers, 'suppliers');
        fetchInventoryOptions(ValidDataService.getValidBrandFilterOptions, setBrands, 'brands');
        fetchInventoryOptions(ValidDataService.getInventoryLocationFilterOptions, setLocations, 'locations');
        fetchPropertyOptions(ValidDataService.getPropertyFilterOptions, setMaterials, 'material');
        fetchPropertyOptions(ValidDataService.getPropertyFilterOptions, setContactLensType, 'contactLensType');

        // fetch suppliers based on the type of inventory item
        const fetchSuppliers = async () => {
            try {
                const response = await ValidDataService.getValidSupplierFilterOptions('contacts');
                const { code, data } = response;
                if (code === 0) {
                    // Transform brands into the format expected by the filter
                    const brandOptions = data.map(brand => ({
                        value: brand.value,
                        label: brand.label
                    }));
                    setSuppliers(brandOptions);
                }
            } catch (error) {
                console.error('Error fetching brands:', error);
            }
        };

        // fetch brands based on the type of inventory item
        const fetchBrands = async () => {
            try {
                const response = await ValidDataService.getValidBrandFilterOptions('contacts');
                const { code, data } = response;
                if (code === 0) {
                    // Transform brands into the format expected by the filter
                    const brandOptions = data.map(brand => ({
                        value: brand.value,
                        label: brand.label
                    }));
                    setBrands(brandOptions);
                }
            } catch (error) {
                console.error('Error fetching brands:', error);
            }
        };

        const fetchLocations = async () => {
            try {
                const response = await ValidDataService.getInventoryLocationFilterOptions('contacts');
                const { code, data } = response;
                if (code === 0) {
                    // Transform locations into the format expected by the filter
                    const locationOptions = data.map(loc => ({
                        value: loc.value,
                        label: loc.label
                    }));
                    setLocations(locationOptions);
                }
            } catch (error) {
                console.error('Error fetching locations:', error);
            }
        };

        // fetch material based on the type of inventory item
        const fetchMaterial = async () => {
            try {
                const response = await ValidDataService.getValidMaterialFilterOptions('contacts');
                const { code, data } = response;
                if (code === 0) {
                    // Transform brands into the format expected by the filter
                    const materialOptions = data.map(material => ({
                        value: material.value,
                        label: material.label
                    }));
                    setMaterials(materialOptions);
                }
            } catch (error) {
                console.error('Error fetching material:', error);
            }
        };

        // fetchLocations();
        // fetchBrands();
        // fetchSuppliers();
        // fetchMaterial();

    }, []);

    return [
        {
            Header: 'Description',
            accessor: 'modelNumber',
            enableFilter: true
        },
        {
            Header: 'Brand',
            accessor: 'brand.name',
            enableFilter: true,
            type: 'enum',
            filterOptions: brands
        },
        {
            Header: 'Supplier',
            accessor: 'supplier.supplierName',
            enableFilter: true,
            type: 'enum',
            filterOptions: suppliers
        },
        {
            Header: 'SKU',
            accessor: 'sku',
            enableFilter: true,
        },          
        {
            Header: 'Material',
            accessor: 'contactproperties.material',
            enableFilter: true,
            type: 'enum',
            filterOptions: materials
        },
        {
            Header: 'Contact Type',
            accessor: 'contactproperties.contactLensType',
            enableFilter: true,
            filterOptions: contactLensType
        },
        {
            Header: 'Schedule',
            accessor: 'contactproperties.wearSchedule',
            enableFilter: true,
            type: 'enum',
            filterOptions: [
                { value: 'daily', label: 'Daily' },
                { value: 'weekly', label: 'Weekly' },
                { value: 'bi-weekly', label: 'Bi-weekly' },
                { value: 'monthly', label: 'Monthly' },
            ]
        },
        {
            Header: 'List Price',
            accessor: 'listPrice',
            enableFilter: true,
            type: 'number'
        },
        {
            Header: 'Expiry Date',
            accessor: 'contactproperties.expirationDate',
            enableFilter: true,
            type: 'date',
            Cell: ({ value }) => formatDateWithTimezone(value)
        },
        {
            Header: 'Location',
            accessor: 'location.name',
            enableFilter: true,
            type: 'enum',
            filterOptions: locations
        },        
    ];
};